import { useState, useEffect } from 'react';

/**
 * Debounces non-empty trimmed search strings (default 1200ms). Empty input updates
 * immediately so clearing the field refetches the full list without waiting.
 */
export function useDebouncedSearchInput(rawInput, delayMs = 1200) {
    const [debounced, setDebounced] = useState('');

    useEffect(() => {
        const trimmed = typeof rawInput === 'string' ? rawInput.trim() : '';
        if (trimmed === '') {
            setDebounced('');
            return;
        }
        const t = setTimeout(() => setDebounced(trimmed), delayMs);
        return () => clearTimeout(t);
    }, [rawInput, delayMs]);

    return debounced;
}
